import { useSettings } from "~/store/settings";

const useHomePage = () => {
	const route = useRoute();
	// const { $ldClient, $ldVariation } = useNuxtApp();

	const isHomePageEnabled = computed(() => true);
	const isHomePage = computed(() => isHomePageEnabled.value && route.name === "index");

	const trackAuthenticationDarkly = (method: "login" | "registration") => {
		// if (!$ldClient) return;
		// try {
		// 	if (method === "login") {
		// 		$ldClient.track("Login");
		// 	} else {
		// 		$ldClient.track("Register");
		// 	}
		// } catch (e) {}
	};

	const trackClickDarkly = (routeTo: string) => {
		// if (!$ldClient) return;
		// try {
		// 	$ldClient.track("HomepageClick", { routeTo });
		// } catch (e) {}
	};

	return { isHomePageEnabled, isHomePage, trackAuthenticationDarkly, trackClickDarkly };
};

export default useHomePage;
